import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Component({
  selector: 'app-agent-registration',
  templateUrl: './agent-registration.component.html',
  styleUrls: ['./agent-registration.component.scss']
})
export class AgentRegistrationComponent implements OnInit {

  form: FormGroup;
  passwordFieldType = 'password';
  error = false;
  isLoading = false;
  confirmed = false;

  userId: string;
  token: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService
  ) {
    this.form = this.formBuilder.group({
      password: [null, [Validators.required]]
    });
  }

  ngOnInit() {
    const params = this.route.snapshot.queryParams;
    this.userId = params.userId;
    this.token = params.token;

    this.authService.confirmResetToken(this.userId, this.token).subscribe(
      response => {
        console.log(response);
        this.confirmed = true;
      },
      error => {
        console.error(error);
        this.error = true;
      });
  }

  reset() {
    const newPassword = this.form.get('password').value;

    this.authService.resetPassword(this.userId, newPassword).subscribe(_ => {
      this.notificationService.showSuccess('Your account has been secured! Please login.');
      this.router.navigate(['/','session','log-in']);
    });
  }

}
